import PropTypes from 'prop-types'
import classNames from 'classnames'

import AvatarPlaceholder from '../../assets/images/mock/default-profile-icon.png'
import SmallMilestoneIcon from '../common/SmallMilestoneIcon'

import classes from './AccountCard.module.scss'
import SubmitButton from '../common/buttons/SubmitButton'
import TooltipText from '../common/TooltipText'

const AccountCard = ({ avatarUrl, fullName, email, age, familyAdmin, division, className, allowReinvite, pendingInvitation, onResendInvitation }) => {
  const userDisplayName = pendingInvitation ? fullName : `${fullName}, ${age} yrs`

  const handleReinvite = (e) => {
    e.preventDefault()
    onResendInvitation()
  }

  return (
    <article className={classNames(classes.accountCard, { [className]: className }, 'd-flex align-items-center')}>
      {!pendingInvitation && (
        <div className={classNames(classes.accountVisuals, 'mr-3')}>
          <div className='medium-round-image-wrapper'>
            <img
              className='round-image'
              src={avatarUrl || AvatarPlaceholder}
              alt='User Avatar'
            />
          </div>

          <div className={classNames(classes.divisionWrapper)}>
            <SmallMilestoneIcon division={division || 1} fromAvatar />
          </div>
        </div>
      )}

      <div className={classNames(classes.accountInfo, 'd-flex flex-column justify-content-center align-items-left')}>
        <p className={classes.fullName}>{userDisplayName}</p>

        {pendingInvitation && (
          <TooltipText text={email} className={classes.smallText} />
        )}


        {pendingInvitation && (
          <span className={classes.specialText}>Pending Invitation</span>
        )}

        {!pendingInvitation && familyAdmin && (
          <span className={classes.specialText}>Family Admin</span>
        )}
      </div>

      {pendingInvitation && allowReinvite && (
        <SubmitButton onClick={handleReinvite} buttonMessage='Reinvite' buttonColor='orange-button' className={classes.resendButton} />
      )}
    </article>
  )
}

AccountCard.propTypes = {
  avatarUrl: PropTypes.string,
  fullName: PropTypes.string,
  email: PropTypes.string,
  age: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  familyAdmin: PropTypes.bool,
  className: PropTypes.string,
  division: PropTypes.number,
  allowReinvite: PropTypes.bool,
  pendingInvitation: PropTypes.bool,
  onResendInvitation: PropTypes.func,
}

export default AccountCard
